import { render, staticRenderFns } from "./VisualizarDadoModal.vue?vue&type=template&id=2983f392&scoped=true"
import script from "./VisualizarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarDadoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983f392",
  null
  
)

export default component.exports